import React from "react";
import middleware from "./middlewares/middleware";
import AllNotificationDashboard from "../component/sections/user/manage/notification-dashboard/All";
import AddNotificationDashboard from "../component/sections/user/manage/notification-dashboard/Add";
import EditNotificationDashboard from "../component/sections/user/manage/notification-dashboard/Edit";

const notificationDashboardRoutes = [
  {
    path: "/user/notification-dashboard/all",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AllNotificationDashboard />,
        "AllNotificationDashboard"
      );
    },
    exact: true,
  },
  {
    path: "/user/notification-dashboard/add",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AddNotificationDashboard />,
        "AddNotificationDashboard"
      );
    },
    exact: true,
  },
  {
    path: "/user/notification-dashboard/edit/:notificationDashboardID",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <EditNotificationDashboard />,
        "EditNotificationDashboard"
      );
    },
    exact: true,
  },
];

export default notificationDashboardRoutes;
